const activeClass = 'is-active'
const header = document.querySelector('.header')
const nav = document.querySelector('.nav')
const dropdownTriggers = document.querySelectorAll('.js-dropdown-trigger')
const dropdownSubmenuLevel2Triggers = document.querySelectorAll(
  '.js-dropdown-submenu-level-2',
)
const dropdownSubmenuLevel2Element = document.querySelectorAll(
  '.js-dropdown-submenu-level-2-element',
)
const dropdownBackLinks = document.querySelectorAll('.js-dropdown-back')

function removeClassFromSubmenuLevel2() {
  dropdownSubmenuLevel2Element.forEach(function (submenuLevel2Element, index) {
    submenuLevel2Element.classList.remove(activeClass)
  })
}

dropdownSubmenuLevel2Triggers.forEach(function (
  dropdownSubmenuLevel2Trigger,
  index,
) {
  const dataTargetedElement =
    dropdownSubmenuLevel2Trigger.dataset.targetedElement
  const navDropdownInner = dropdownSubmenuLevel2Trigger.closest(
    '.nav__dropdown-inner',
  )

  dropdownSubmenuLevel2Trigger.addEventListener('mouseenter', function () {
    if (window.innerWidth > 959) {
      removeClassFromSubmenuLevel2()
      const parent = this.parentNode
      const text = this.querySelector('span').textContent

      parent.classList.add(activeClass)

      const targetElement = this.closest('.nav__dropdown-body').querySelector(
        '[data-target-element="' + dataTargetedElement + '"]',
      )
      targetElement.classList.add(activeClass)

      for (let sibling of parent.parentNode.children) {
        if (sibling !== parent) sibling.classList.remove(activeClass)
      }

      navDropdownInner.addEventListener('mouseleave', function () {
        if (window.innerWidth > 959) {
          //dropdownCurrentElement.classList.remove(activeClass);

          for (let sibling of parent.parentNode.children) {
            if (sibling !== parent) sibling.classList.remove(activeClass)
          }

          removeClassFromSubmenuLevel2()
        }
      })
    }
  })

  dropdownSubmenuLevel2Trigger.addEventListener('click', function (evt) {
    if (window.innerWidth < 960) {
      const parent = this.parentNode
      const target = this.dataset.targetedElement

      const body = this.closest('.nav__dropdown-body')
      const content = body.querySelector(
        `.nav__dropdown-content .nav__dropdown-item[data-target-element="${target}"] .nav__dropdown-item-body`,
      )

      //only continue if the body is present
      if (content === null) {
        return true
      }

      evt.preventDefault()
      const dataTargetedElement = evt.currentTarget.dataset.targetedElement
      const targetElement = this.closest('.nav__dropdown-body').querySelector(
        '[data-target-element="' + dataTargetedElement + '"]',
      )
      targetElement.classList.add(activeClass)

      for (let sibling of parent.parentNode.children) {
        if (sibling !== parent) sibling.classList.remove(activeClass)
      }
    }
  })
})

dropdownTriggers.forEach(function (dropdownTrigger, index) {
  dropdownTrigger.addEventListener('click', function (evt) {
    if (window.innerWidth < 960) {
      evt.preventDefault()
      const dropdown = this.nextElementSibling

      dropdown.classList.add(activeClass)
    } else {
      header.classList.add('is-active')

      let parent = evt.target.parentNode
      let isActive = parent.classList.contains('is-active')
      //remove for all others
      dropdownTriggers.forEach((element) => {
        element.parentNode.classList.remove('is-active')
      })

      parent.classList.toggle('is-active')

      if (isActive) {
        parent.classList.remove('is-active')
      } else {
        parent.classList.add('is-active')
      }

      parent
        .querySelectorAll('.nav__dropdown .nav__dropdown-aside ul li')
        .forEach((element, index) => {
          if (index == 0) {
            element.classList.add('is-active')
          } else {
            element.classList.remove('is-active')
          }
        })

      parent
        .querySelectorAll(
          '.nav__dropdown .nav__dropdown-content .nav__dropdown-item',
        )
        .forEach((element, index) => {
          if (index == 0) {
            element.classList.add('is-active')
          } else {
            element.classList.remove('is-active')
          }
        })
    }
  })
})

dropdownBackLinks.forEach(function (dropdownBack, index) {
  dropdownBack.addEventListener('click', function (evt) {
    if (window.innerWidth < 960) {
      evt.preventDefault()
      const dropdown = this.closest('.nav__dropdown, .nav__dropdown-item')

      dropdown.classList.remove(activeClass)
    }
  })
})
